import React from "react";
import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";

const ColumnCheckboxes = ({ columns, handleSelectAll, handleSelectColumn }) => {
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            checked={columns.every((value) => value.isHidden === false)}
            onChange={handleSelectAll}
          />
        }
        label="Select All"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={columns.some((column) =>
              column.id === "col3" ? !column.isHidden : false
            )}
            onChange={() => handleSelectColumn("col3")}
          />
        }
        label="Status"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={columns.some((column) =>
              column.id === "col6" ? !column.isHidden : false
            )}
            onChange={() => handleSelectColumn("col6")}
          />
        }
        label="Label"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={columns.some((column) =>
              column.id === "col7" ? !column.isHidden : false
            )}
            onChange={() => handleSelectColumn("col7")}
          />
        }
        label="Milestone"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={columns.some((column) =>
              column.id === "col8" ? !column.isHidden : false
            )}
            onChange={() => handleSelectColumn("col8")}
          />
        }
        label="Allocated Hours"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={columns.some((column) =>
              column.id === "col9" ? !column.isHidden : false
            )}
            onChange={() => handleSelectColumn("col9")}
          />
        }
        label="Hours Spent"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={columns.some((column) =>
              column.id === "col10" ? !column.isHidden : false
            )}
            onChange={() => handleSelectColumn("col10")}
          />
        }
        label="Time Tracking"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={columns.some((column) =>
              column.id === "col11" ? !column.isHidden : false
            )}
            onChange={() => handleSelectColumn("col11")}
          />
        }
        label="Due Date"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={columns.some((column) =>
              column.id === "col12" ? !column.isHidden : false
            )}
            onChange={() => handleSelectColumn("col12")}
          />
        }
        label="Created Date"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={columns.some((column) =>
              column.id === "col13" ? !column.isHidden : false
            )}
            onChange={() => handleSelectColumn("col13")}
          />
        }
        label="Reporter"
      />
    </FormGroup>
  );
};

export default ColumnCheckboxes;
